import { useState, useEffect } from "react";
import { useT } from "../lib/i18n";

const GA_ID = "G-9KKYCNMYBG";
const AW_ID = "AW-18193661676";
const META_PIXEL_ID = "2754942898215732";

function loadTracking() {
  if (document.getElementById("ga-script")) return;
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag("js", new Date());
    gtag("config", GA_ID);
    gtag("config", AW_ID);
    window.gtag = gtag;
  };

  // Meta Pixel
  if (!window.fbq) {
    const f = window, b = document, e = "script";
    const v = "https://connect.facebook.net/en_US/fbevents.js";
    let n;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    const tag = b.createElement(e); tag.async = true; tag.src = v;
    const s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(tag, s);
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export default function CookieBanner() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      loadTracking();
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
    loadTracking();
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full bg-[#1A1A1A] text-[#F8F5F2] border-t border-[#F8F5F2]/15 p-6 md:p-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-[#F8F5F2]/85">
            <p>{t("cookies.text")}</p>
            <a href="/privacy" target="_blank" rel="noreferrer" className="text-[#6E1A24] underline text-xs mt-1 inline-block">Privacy Policy</a>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={decline}
              className="px-4 py-2 text-xs uppercase tracking-widest border border-[#F8F5F2]/30 hover:border-[#F8F5F2] transition-colors"
            >
              {t("cookies.decline")}
            </button>
            <button
              onClick={accept}
              className="px-4 py-2 text-xs uppercase tracking-widest bg-[#6E1A24] hover:bg-[#8B2230] transition-colors"
            >
              {t("cookies.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
